import { motion } from "framer-motion";
import { Logo } from "@/components/store/Logo";
import { BuyButton } from "@/components/store/BuyButton";
import { PRODUCT } from "@/constants/product";

const links = [["#system", "The system"], ["#inside", "Inside"], ["#loop", "Weekly loop"], ["#faq", "FAQ"]];

export const SiteNav = () => (
  <motion.header initial={{ y: -40, opacity: 0.4 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, delay: 0.2 }}
    className="fixed inset-x-0 top-0 z-40 px-3 pt-3 sm:px-6 sm:pt-4">
    <div className="mx-auto flex max-w-[1360px] items-center justify-between rounded-full border border-black/10 bg-[#fbf8f1]/80 py-2 pl-4 pr-2 backdrop-blur-xl sm:pl-5">
      <Logo />
      <nav className="hidden items-center gap-1 text-sm font-medium lg:flex">
        {links.map(([href, label]) => (
          <a key={href} href={href} className="rounded-full px-4 py-2 transition-colors hover:bg-black/5" data-testid={`nav-link-${href.slice(1)}`}>{label}</a>
        ))}
      </nav>
      <BuyButton small label={`Buy · ${PRODUCT.price}`} testId="nav-buy-button" />
    </div>
  </motion.header>
);
